




























































































import Vue from "vue";

import { mapGetters, mapState } from "vuex";
import marked from "marked";
import Api from "../../api/Api";
import JwtTokenObject from "../../interfaces/jwttokenobject";
import With from "../../components/With.vue";

interface DataType {
  showNote: boolean;
}

interface MethodType {
  toggleNote(): void;
}

interface ComputedType {
  document: string;
}

const api = Api.singleton();
export default Vue.extend({
  components: { With },
  computed: {
    ...mapState(["document", "headerProcess"]),
    ...mapGetters(["my", "impersonator"]),
    jwtToken(): JwtTokenObject | undefined {
      return api.jwtToken.currentTokenObject;
    },
    marked(): string {
      if (this.document) {
        return marked(this.document || "");
      }
      return "";
    },
    layout(): string {
      return (this.$route.meta.layout || "default") + "-layout";
    },
  },
  data() {
    return {
      showNote: false,
    };
  },
  methods: {
    isImpersonated(): boolean {
      return api.jwtToken.isGranted(["ROLE_IMPERSONATOR"]);
    },
    toggleNote(): void {
      this.showNote = !this.showNote;
    },
    async logout() {
      this.$router.push({ name: "Login" });
      this.$store.dispatch("logout");
    },
    async unimpersonate() {
      await this.$store.dispatch("unimpersonate");
      this.$router.push({ name: "AdministratorIndex" });
    },
  },
  mounted() {
    if (!window.document.getElementById("script-veritrans-pop")) {
      const externalScript = document.createElement("script");
      externalScript.setAttribute("id", "script-veritrans-pop");
      externalScript.setAttribute(
        "src",
        "https://pay3.veritrans.co.jp/pop/v1/javascripts/pop.js"
      );
      externalScript.setAttribute(
        "data-client-key",
        "" + process.env.VUE_APP_VERITRANS_POP_CLIENT_KEY
      );
      document.head.appendChild(externalScript);
    }
  },
}); // as ThisTypedComponentOptionsWithRecordProps<Vue, DataType, MethodType, ComputedType, {}>);
